import { AllowListPhoneNumberFragment, GetAllowListPhoneNumbersQuery } from '@occc/graphql';

export const transformDataToAllowListPhoneNumbersArray = (
  data: GetAllowListPhoneNumbersQuery,
): AllowListPhoneNumberFragment[] => data.getAllowListPhoneNumbers.edges.map((item) => item.node);

export const parseStringToDate = (date: string) => new Date(date);
